import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Components
import Link from '../../components/Link';

// Locale
import messages from '../../locale/messages';
import s from './UserBanned.css';

class UserBanned extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    siteName: PropTypes.string.isRequired,
    formatMessage: PropTypes.func,
  };

  render() {
    const { siteName } = this.props;
    return (
      <div className={s.userBannedContainer}>
        <div className={s.textCenter}>
          <h1 className={cx(s.userBannedHeading)}>
            <FormattedMessage {...messages.userBannedTitle} />
          </h1>
          <h2 className={s.subText}>
            <FormattedMessage {...messages.userBannedSubTitle} />&nbsp;
            <Link to={"/contact"} className={s.contactLink}>
              <FormattedMessage {...messages.contactAdmin} />
            </Link>
          </h2>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(UserBanned)));
